var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { List } from "linq.ts";
import { isNullOrEmpty } from "./string-helper";
export const paginateDataAsync = (request, options) => __awaiter(void 0, void 0, void 0, function* () {
    return paginateData(request, options);
});
export const paginateData = (request, options) => {
    // Crear lista de elementos
    let result = new List(options.data().slice());
    const order = options.order || [];
    // Filtrar datos
    if (request.Search && request.Search.trim().length > 0) {
        // Obtener valor a buscar
        const search = request.Search.trim().toUpperCase();
        // Filtrar
        result = result.Where((item) => {
            // Obtener valores a comparar
            if (options.onSearch != null) {
                return options.onSearch(search, item);
            }
            else {
                const values = options.search(item);
                if (values.length === 0) {
                    return true;
                }
                else {
                    for (let i = 0; i < values.length; i++) {
                        const value = values[i].toUpperCase();
                        if (!isNullOrEmpty(value) && value.indexOf(search) >= 0) {
                            return true;
                        }
                    }
                    return false;
                }
            }
        });
    }
    // Ordenar
    if (typeof options.onSort === 'function') {
        result = options.onSort(result);
    }
    else {
        if (request.OrderColumn !== void 0) {
            const orderColumn = order[request.OrderColumn];
            if (orderColumn !== void 0) {
                if (request.SortDirection === 'asc') {
                    result = result.OrderBy(o => o[orderColumn]);
                }
                else {
                    result = result.OrderByDescending(o => o[orderColumn]);
                }
            }
        }
    }
    const count = result.Count();
    // Paginar
    request.Start = (request.Start - 1) < 0 ? 0 : (request.Start - 1);
    result = result.Skip(request.Start * request.Length).Take(request.Length);
    const dtResult = {
        Data: result.ToArray(),
        RecordsFiltered: count
    };
    return dtResult;
};
